var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plot-edit-page"},[(_vm.isPC)?[_c('plot-edit',{attrs:{"novel-id":_vm.novelId,"plots":_vm.plot,"plotId":_vm.plotId}})]:[_c('plot-edit-sp',{attrs:{"novel-id":_vm.novelId,"plots":_vm.plot,"plotId":_vm.plotId}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }